import { call, put } from 'redux-saga/effects';
import { takeEvery } from 'redux-saga';
import config from '../../config';
import request from 'superagent';

const auth = () => localStorage.getItem('legendbeds.authtoken');

export function* fetch_hk_items() {
    yield* takeEvery("HK_ITEMS/FETCH", function* (action) {
        try {
            yield put({ type: 'LOADING/SET', loading: true });
            const result = yield call(({ id }) => {
                return request.get(`${config.apiEndpoint}/api/v4/housekeeping/items/${id}`)
                    .set('auth_token', auth())
                    .then(data => JSON.parse(data.text));
            }, action);
            if (result && result.success) {
                yield put({ type: 'HK_ITEMS/SET', items: result.items });
            }
            yield put({ type: 'LOADING/SET', loading: false });
        } catch (e) {
            yield put({ type: 'LOADING/SET', loading: false });
        }
    });
}

export function* create_hk_item() {
    yield* takeEvery("HK_ITEM/CREATE", function* (action) {
        try {
            yield put({ type: 'LOADING/SET', loading: true });
            const result = yield call(({ id, Name, Category, Unit, Stock, MinStock }) => {
                return request.post(`${config.apiEndpoint}/api/v4/housekeeping/items/${id}`)
                    .send({ Name, Category, Unit, Stock, MinStock })
                    .set('auth_token', auth())
                    .then(data => JSON.parse(data.text));
            }, action);
            if (result && result.success) {
                yield put({ type: 'HK_ITEMS/FETCH', id: action.id });
            }
            yield put({ type: 'LOADING/SET', loading: false });
        } catch (e) {
            yield put({ type: 'LOADING/SET', loading: false });
        }
    });
}

export function* update_hk_item() {
    yield* takeEvery("HK_ITEM/UPDATE", function* (action) {
        try {
            yield put({ type: 'LOADING/SET', loading: true });
            const result = yield call(({ IdItem, Name, Category, Unit, MinStock }) => {
                return request.patch(`${config.apiEndpoint}/api/v4/housekeeping/items/${IdItem}`)
                    .send({ Name, Category, Unit, MinStock })
                    .set('auth_token', auth())
                    .then(data => JSON.parse(data.text));
            }, action);
            if (result && result.success) {
                yield put({ type: 'HK_ITEMS/FETCH', id: action.IdProperty });
            }
            yield put({ type: 'LOADING/SET', loading: false });
        } catch (e) {
            yield put({ type: 'LOADING/SET', loading: false });
        }
    });
}

export function* delete_hk_item() {
    yield* takeEvery("HK_ITEM/DELETE", function* (action) {
        try {
            yield put({ type: 'LOADING/SET', loading: true });
            const result = yield call(({ id }) => {
                return request.delete(`${config.apiEndpoint}/api/v4/housekeeping/items/${id}`)
                    .set('auth_token', auth())
                    .then(data => JSON.parse(data.text));
            }, action);
            if (result && result.success) {
                yield put({ type: 'HK_ITEMS/FETCH', id: action.IdProperty });
            }
            yield put({ type: 'LOADING/SET', loading: false });
        } catch (e) {
            yield put({ type: 'LOADING/SET', loading: false });
        }
    });
}

export function* fetch_hk_movements() {
    yield* takeEvery("HK_MOVEMENTS/FETCH", function* (action) {
        try {
            const result = yield call(({ id }) => {
                return request.get(`${config.apiEndpoint}/api/v4/housekeeping/movements/${id}`)
                    .set('auth_token', auth())
                    .then(data => JSON.parse(data.text));
            }, action);
            if (result && result.success) {
                yield put({ type: 'HK_MOVEMENTS/SET', movements: result.movements });
            }
        } catch (e) { }
    });
}

export function* register_hk_movement() {
    yield* takeEvery("HK_MOVEMENT/REGISTER", function* (action) {
        try {
            yield put({ type: 'LOADING/SET', loading: true });
            const result = yield call(({ IdItem, IdProperty, Type, Quantity, Notes, IdStaff }) => {
                return request.post(`${config.apiEndpoint}/api/v4/housekeeping/movements`)
                    .send({ IdItem, IdProperty, Type, Quantity, Notes, IdStaff })
                    .set('auth_token', auth())
                    .then(data => JSON.parse(data.text));
            }, action);
            if (result && result.success) {
                yield put({ type: 'HK_ITEMS/FETCH', id: action.IdProperty });
                yield put({ type: 'HK_MOVEMENTS/FETCH', id: action.IdItem });
            }
            yield put({ type: 'LOADING/SET', loading: false });
        } catch (e) {
            yield put({ type: 'LOADING/SET', loading: false });
        }
    });
}
